import { getController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';
import { errorMsg, mixin } from '@/utils/mixins';
import router from '@/router/index';

export default {
  namespaced: true,
  state: {
    fields: {},
    tableTitleParams: {},
    metadata: {},
    detailView: {},
    loading: false
  },
  mixins: [mixin],
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setFields(state, data) {
      state.fields = { ...data };
    },
    setLoading(state, val) {
      state.loading = val;
    }
  },
  actions: {
    async loadCoordinations({ commit, rootState }, intentToQuery) {
      commit('setParam', { name: 'loading', val: true });
      try {
        let filters = {};
        let currentFilters = rootState.filters.filterConfig.filters;
        let dataSortParams = rootState.filters.filterConfig.sortable;

        for (let key in currentFilters) {
          if (currentFilters[key].value != null) {
            filters[key] = currentFilters[key].value;
          }
        }

        const params = {};

        if (rootState.filters.query) {
          params.query = true;
          commit(
            'filters/setParam',
            {
              name: 'query',
              val: false
            },
            { root: true }
          );
        }

        if (dataSortParams?.orderBy) {
          params['orderBy'] = dataSortParams.orderBy;
        }
        if (dataSortParams?.sortOrder) {
          params['sortOrder'] = dataSortParams.sortOrder;
        }

        const intent = intentToQuery || {
          module: 'HRPAC_COORDINATION',
          action: 'getCoordinationRequestsListView',
          intentArea: 'DynamicPage',
          intentType: 'StaticPage',
          request: {
            url: '/index.php?module=HRPAC_COORDINATION&action=getCoordinationRequestsListView',
            request_params: {
              displayMode: 'spa',
              HRPAC_COORDINATION2_HRPAC_COORDINATION_offset: 0
            }
          }
        };

        const request = await mixin.methods.sendFormRequestFromIntent(intent);
        const tableData = request.data?.data?.data?.data;
        const pageData = request.data?.data?.pageData;
        const sugarconfig = request.data?.sugarconfig;
        const customSearch = request.data?.custom_search;

        commit(
          'common/setTableData',
          {
            module: MODULE.COORDINATION_REQUEST,
            columns: tableData?.title,
            rows: tableData?.rows
          },
          { root: true }
        );

        commit('selectionPopup/setMetadataFields', sugarconfig, {
          root: true
        });

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/popupPageConfig', pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', customSearch, {
          root: true
        });

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !customSearch?.sortable?.default || false
          },
          { root: true }
        );

        commit('setParam', {
          name: 'metadata',
          val: request.data
        });

        if (tableData?.title_params) {
          commit('setParam', {
            name: 'tableTitleParams',
            val: tableData?.title_params
          });
        }
        commit('setParam', { name: 'loading', val: false });
      } catch (error) {
        commit('setParam', {
          name: 'metadata',
          val: error.response.data
        });
        commit('setParam', { name: 'loading', val: false });
      }
    },
    async getCoordinationDetailView({ commit }, id) {
      try {
        commit('setParam', { name: 'loading', val: true });

        const response = await getController({
          params: {
            module: MODULE.COORDINATION,
            action: 'getCoordinationDetailView',
            record: id,
            coordination_mode: 'requests_only',
            displayMode: 'spa'
          }
        });
        commit('setParam', {
          name: 'detailView',
          val: response.data
        });

        if (response.data?.bean?.id.value) {
          return true;
        } else {
          if (response.data?.status === 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
            router.push('/coordination_request');
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setParam', { name: 'loading', val: false });
      }
    }
  }
};
